import { useContext, useEffect, useState } from 'react';
import { context } from '../../../globalState/GlobalState';
import { canClaimNCRFreeYear, hasPublishedDomain, isRugbySportsType } from '../../../catalog/NCR';
import { isValidString } from '../../../catalog/Validity';
import { fetchSubscriptionStatusAPI } from '../subscriptions/SubscriptionsAPICalls';

/**
 * Whether this team can still claim the NCR free year (see canClaimNCRFreeYear). The subscription
 * lookup only runs for rugby teams without a domain, and a failed lookup counts as not eligible.
 */
const useNCRClaimEligibility = () => {
    const { globalState } = useContext(context);
    const [status, setStatus] = useState({ loading: true, fetched: false, websiteSubscriptionActive: false, domainSubscriptionActive: false });
    const needsLookup = isRugbySportsType(globalState.sportsType) && !hasPublishedDomain(globalState) && isValidString(globalState.teamId);

    useEffect(() => {
        if (!needsLookup) {
            setStatus((previous) => { return { ...previous, loading: false }; });
            return undefined;
        }
        let cancelled = false;
        setStatus((previous) => { return { ...previous, loading: true }; });
        const onStatus = (action) => {
            if (!cancelled && action.type === 'setSubscriptionActive') {
                setStatus({ loading: false, fetched: true, websiteSubscriptionActive: action.websiteSubscriptionActive, domainSubscriptionActive: action.domainSubscriptionActive });
            }
        };
        fetchSubscriptionStatusAPI(globalState.teamId, onStatus, () => {}).finally(() => {
            if (!cancelled) {
                setStatus((previous) => { return { ...previous, loading: false }; });
            }
        });
        return () => { cancelled = true; };
    }, [needsLookup, globalState.teamId]);

    return {
        loading: status.loading,
        eligible: needsLookup && status.fetched && canClaimNCRFreeYear(globalState, status.websiteSubscriptionActive, status.domainSubscriptionActive),
    };
};

export default useNCRClaimEligibility;
